/* eslint-disable no-console */
import {IAppliedRule, RuleOperator, RuleResultType} from '../incase-domain/appliedRules';

export const testShouldBlock = (appliedRule: IAppliedRule, slideId: string): boolean => {
    const predicate = appliedRule.predicates[0];
    const result = appliedRule.results[0];

    if (result.resultType !== RuleResultType.BLOCK_SLIDE || result.slideIds.length === 0 || !result.slideIds.includes(slideId)) {
        return false;
    }

    return predicate.operator === RuleOperator.IF ? !!appliedRule.satisfied : !appliedRule.satisfied;
};
